
import { cn } from '@/lib/utils';

/**
 * LoadingState Component
 * Displays a skeleton card with gentle pulsing animation
 * while prayers are being loaded
 */
export function LoadingState() {
  return (
    <div 
      className={cn(
        "bg-white dark:bg-slate-800 rounded-2xl shadow-xl",
        "p-6 sm:p-8 max-w-md w-full mx-auto",
        "animate-pulse"
      )}
      role="status"
      aria-label="Loading prayer"
    >
      {/* Category badge skeleton */}
      <div className="mb-4 flex gap-2">
        <div className="h-7 w-20 bg-slate-200 dark:bg-slate-700 rounded-full" />
      </div>
      
      {/* Prayer body skeleton - multiple lines */}
      <div className="mb-6 space-y-3">
        <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded w-full" />
        <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded w-full" />
        <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded w-3/4" />
        <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded w-5/6" />
      </div>
      
      {/* Author info skeleton */}
      <div className="mb-6 pb-6 border-b border-slate-200 dark:border-slate-700">
        <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-32" />
      </div>
      
      {/* Button skeleton */}
      <div className="h-14 bg-slate-200 dark:bg-slate-700 rounded-xl" />
      
      {/* Screen reader text */}
      <span className="sr-only">Loading prayer request...</span>
    </div>
  );
}

/**
 * FullScreenLoader Component
 * A centered loading state with spinner for initial page load
 */
export function FullScreenLoader() {
  return (
    <div 
      className={cn(
        "flex flex-col items-center justify-center",
        "min-h-[50vh] w-full"
      )}
      role="status"
      aria-label="Loading"
    >
      {/* Animated spinner */}
      <div className="relative">
        <div 
          className={cn(
            "w-16 h-16 border-4 border-primary-200 dark:border-primary-900",
            "rounded-full animate-spin"
          )}
          style={{ borderTopColor: 'rgb(37 99 235)' }}
        />
      </div>
      
      {/* Loading text */}
      <p className="mt-4 text-slate-600 dark:text-slate-400 font-medium">
        Loading prayers...
      </p>
      
      {/* Screen reader text */}
      <span className="sr-only">Loading prayer requests, please wait...</span>
    </div>
  );
}

export default LoadingState;
